import React, { Component } from 'react';
import Highlighter from 'react-highlight-words';
import Tooltip from 'react-tooltip';
import {
    ProductNameBox,
    Checkbox,
    Dropdown,
    Button,
    Timer,
    Modal,
} from '../../../common/';
import I18n from '../../../../i18n/I18n';
import Helper from '../../../../helper/Helper';
import styles from '../../../orders/orderTable/OrderTable.scss';

class ProductTable extends Component {
    state = {
        pendingQty: this.props.item && this.props.item.pending_qty,
        updatedQty: this.props.item && this.props.item.qty,
        modalOpen: false,
        outOfStockBtn: false,
    };
    componentDidUpdate = (prevProps, prevState) => {
        if (
            prevProps.item &&
            this.props.item &&
            !prevProps.item.pending_qty &&
            this.props.item.pending_qty
        ) {
            this.setState({
                pendingQty: this.props.item.pending_qty,
            });
        }
        if (prevProps.item !== this.props.item) {
            this.setState({
                updatedQty: this.props.item.qty,
            });
        }
    };
    selectQtyChange(e) {
        this.setState({
            pendingQty: e.value,
        });
        if (this.props.item.pending_qty !== e.value) {
            this.openModal();
        }
        const obj = {
            id_partner: this.props.seller ? this.props.seller.id_partner : '',
            sku: this.props.item.sku,
            qty: e.value,
        };

        this.props.onQtyChange(obj);
    }

    onOutOfStock = () => {
        const obj = this.props.item.sku;
        const qty = this.state.outOfStockBtn ? 0 : this.state.pendingQty;

        this.props.onOutOfStock(obj, qty);
        this.onCloseModal();
    };

    makeOutOfStock = () => {
        this.setState({
            outOfStockBtn: true,
            modalOpen: true,
        });
    };

    openModal = () => {
        this.setState({
            modalOpen: true,
        });
    };
    onCloseModal = () => {
        this.setState({
            modalOpen: false,
            outOfStockBtn: false,
        });
    };

    updateQty = e => {
        this.setState({
            updatedQty: e.value,
        });
    };
    onUpdate = () => {
        const obj = {
            id_picklist: this.props.item.id_picklist,
            stock_reduced: [
                {
                    sku: this.props.item.sku,
                    qty: this.state.updatedQty,
                },
            ],
        };
        this.props.onUpdateQty(obj);
    };
    render() {
        const {
            item,
            searchString,
            property,
            toggleCheckbox,
            seller,
            selectedItems,
            dropdown,
            status,
        } = this.props;

        const obj = {
            id_partner: seller ? seller.id_partner : '',
            sku: item.sku,
            qty: this.state.pendingQty,
        };

        const match =
            selectedItems &&
            selectedItems.find(thisItem => {
                return thisItem && thisItem.sku === item.sku;
            });

        const qtyOptions = [];
        for (let i = item.pending_qty; i >= 1; i--) {
            qtyOptions.push({ value: i, label: `${i}` });
        }

        const updateQtyOptions = [];
        for (let i = item.qty; i >= 0; i--) {
            updateQtyOptions.push({ value: i, label: `${i}` });
        }

        return (
            <tr className={`${styles.row} ${match ? styles.selected : ''}`}>
                {toggleCheckbox ? (
                    <td>
                        <Checkbox
                            checked={match}
                            onClick={() => toggleCheckbox(obj)}
                            name={item.sku}
                        />
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('title') ? (
                    <td>
                        <a
                            target="_blank"
                            href={`${Helper.getAppDomain(
                                'catalog',
                            )}/${Helper.getLocale()}/catalog/${
                                item.psku_canonical
                            }`}
                        >
                            <ProductNameBox
                                hideBadge
                                data={item}
                                searchString={searchString}
                            />
                        </a>
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('sku') ? (
                    <td>
                        <Highlighter
                            highlightClassName={styles.highlight}
                            searchWords={[searchString]}
                            autoEscape={true}
                            textToHighlight={item.sku}
                        />
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('partner_sku_unique') ? (
                    <td>
                        <Highlighter
                            highlightClassName={styles.highlight}
                            searchWords={[searchString]}
                            autoEscape={true}
                            textToHighlight={item.partner_sku_unique}
                        />
                    </td>
                ) : (
                    ''
                )}
                {property.haveQtyVal('qty') ? (
                    <td>
                        {status === 2 ? (
                            <div className={styles.dropdownWrapper}>
                                <Dropdown
                                    options={updateQtyOptions}
                                    dropdownClass={styles.dropdown}
                                    height="short"
                                    value={this.state.updatedQty}
                                    onChange={e => this.updateQty(e)}
                                />
                            </div>
                        ) : (
                            item.qty
                        )}
                    </td>
                ) : (
                    ''
                )}
                {dropdown ? (
                    <td>
                        <div
                            className={styles.dropdownWrapper}
                            onClick={!match ? () => toggleCheckbox(obj) : ''}
                        >
                            <Dropdown
                                options={qtyOptions}
                                dropdownClass={styles.dropdown}
                                height="short"
                                value={this.state.pendingQty}
                                onChange={e => this.selectQtyChange(e)}
                            />
                        </div>
                    </td>
                ) : (
                    ''
                )}

                {status === 2 ? (
                    <td>
                        <Button
                            variant="secondary"
                            style={{ padding: '12px 15px' }}
                            disabled={
                                Number(this.props.item.qty) ===
                                Number(this.state.updatedQty)
                            }
                            onClick={this.onUpdate}
                        >
                            {I18n.getText('stock-request.update-qty')}
                        </Button>
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('fulfilment_date') ? (
                    <td>
                        <Timer endDate={item.fulfilment_date} />
                    </td>
                ) : (
                    ''
                )}
                {status === 1 ? (
                    <td>
                        <Button
                            variant="warning"
                            style={{ padding: '12px 15px' }}
                            onClick={() => this.makeOutOfStock()}
                        >
                            {I18n.getText('stock-request.make-oos-btn')}
                        </Button>
                    </td>
                ) : (
                    ''
                )}
                <td>
                    <Modal
                        contentLabel={'OutOStock'}
                        isOpen={this.state.modalOpen}
                        closeModal={() => this.onCloseModal()}
                        modalClass={styles.outOfStockModal}
                        modalInnerClassName={styles.oosModalInner}
                    >
                        <div className={styles.oosTitle}>
                            {I18n.getText('stock-request.confirm-oos')}
                        </div>
                        <div className={styles.oosMsg}>
                            {this.state.outOfStockBtn
                                ? I18n.getText('stock-request.no-qty-oosMsg', {
                                      itemName: item.title,
                                  })
                                : I18n.getHtml('stock-request.oosMsg', {
                                      countInStock: this.state.pendingQty,
                                      oosCount:
                                          item.pending_qty -
                                          this.state.pendingQty,
                                      itemName: item.title,
                                  })}
                        </div>
                        <div className={styles.btnWrapper}>
                            <Button
                                variant="warning"
                                className={styles.btn}
                                onClick={() => this.onOutOfStock()}
                            >
                                {this.state.outOfStockBtn
                                    ? I18n.getText('order-details.confirm')
                                    : I18n.getText('stock-request.make-oos', {
                                          count:
                                              item.pending_qty -
                                              this.state.pendingQty,
                                      })}
                            </Button>
                            <Button
                                variant="secondary"
                                className={styles.btn}
                                onClick={this.onCloseModal}
                            >
                                {this.state.outOfStockBtn
                                    ? I18n.getText('outbound.cancel')
                                    : I18n.getText(
                                          'stock-request.fulfill-later',
                                          {
                                              count:
                                                  item.pending_qty -
                                                  this.state.pendingQty,
                                          },
                                      )}
                            </Button>
                        </div>
                    </Modal>
                </td>
            </tr>
        );
    }
}

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/stockRequest/productTable/productRow/ProductRow.js